import { useEffect, useRef } from 'react';

import { throttle } from '@/utils/throttle';

export const useWindowWidthResize = (handler: (event: UIEvent) => void) => {
  const prevWindowSizeRef = useRef(typeof window === 'undefined' ? 0 : window.innerWidth);

  useEffect(() => {
    const handle = (event: UIEvent) => {
      const prevWindowWidth = prevWindowSizeRef.current;
      const curWindowWidth = window.innerWidth;

      if (prevWindowWidth === curWindowWidth) {
        return;
      }

      prevWindowSizeRef.current = curWindowWidth;
      handler(event);
    };

    const throttled = throttle({ func: handle, timeout: 300 });

    window.addEventListener('resize', throttled);

    return () => {
      window.removeEventListener('resize', throttled);
    };
  }, [handler]);
};
